import Vue from 'vue';
import BreadcrumbsApp from './components/breadcrumbs_app.vue';

export default () => {
  const el = document.getElementById('js-breadcrumbs');

  if (!el) {
    return false;
  }

  return new Vue({
    el,
    name: 'BreadcrumbsRoot',
    render: (createElement) => createElement(BreadcrumbsApp),
  });
};
